const config = {
  appEnv: process.env.REACT_APP_ENV,
  baseUrl: process.env.REACT_APP_SERVER_URL,
  sportsBookBaseUrl: process.env.REACT_APP_SPORTSBOOK_API_URL,
  defaultLanguage: process.env.REACT_APP_LANGUAGE || "es",
  refUrl: process.env.REACT_APP_REFERRAL_BASE_URL || "",
  sportsIframeID: process.env.REACT_APP_SPORTS_IFRAME_ID || "",
  domainKey: process.env.REACT_APP_DOMAIN_KEY,
  pusherAppKey: process.env.REACT_APP_PUSHER_APP_KEY,
  pusherAppCluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
  awsRegion: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_IKA,
  secretAccessKey: process.env.REACT_APP_KAS,
  sportBookSocketUrl: process.env.REACT_APP_WEBSOCKET_CHANNEL,
  eKey: process.env.REACT_APP_KE,
  socketEncryptionKey: process.env.REACT_APP_SOCKET_ENCRYPTION_KEY,
  liveMarkets: process.env.REACT_APP_DYNAMO_LIVE_MARKET || "TABLE",
  livePartialDevent:
    process.env.REACT_APP_DYNAMO_LIVE_PARTIAL_DEVENT || "TABLE",
  liveMatches: process.env.REACT_APP_DYNAMO_LIVE_MATCHES || "TABLE",
  prematchMarket: process.env.REACT_APP_DYNAMO_PREMATCH_MARKET || "TABLE",
  prematchPartialDevent:
    process.env.REACT_APP_DYNAMO_PREMATCH_PARTIAL_DEVENT || "TABLE",
  finishedEvent: process.env.REACT_APP_DYNAMO_FINISHED_EVENT || "TABLE",
  showCopyMarketId: process.env.REACT_APP_COPY_MARKET_ID_ENABLED
};

export default config;
